









































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LocationDetails from '@/components/LocationDetails.vue';
import { getImgUrl } from '../utils/dummy';
import { HOST } from '@/global';
import { gmapApi } from 'vue2-google-maps';
import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';
@Component({
  name: 'locations',
  components: {
    LocationDetails
  }
})
export default class Locations extends Vue {
  @Prop() compData: any;
  HOST: string = HOST;
  public windowWidth: number = window.innerWidth;

  public activeTabIdx: number = 0;
  public activeAddressIdx: number = 0;
  public center: any = {};
  gmapStyles: any = [
    {
      elementType: 'geometry',
      stylers: [
        {
          color: '#f5f5f5'
        }
      ]
    },
    {
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#616161'
        }
      ]
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#f5f5f5'
        }
      ]
    },
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#bdbdbd'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        {
          color: '#eeeeee'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575'
        }
      ]
    },
    {
      featureType: 'poi.business',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          color: '#e5e5e5'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#9e9e9e'
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [
        {
          color: '#ffffff'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#dadada'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#616161'
        }
      ]
    },
    {
      featureType: 'road.local',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#9e9e9e'
        }
      ]
    },
    {
      featureType: 'transit.line',
      elementType: 'geometry',
      stylers: [
        {
          color: '#e5e5e5'
        }
      ]
    },
    {
      featureType: 'transit.station',
      elementType: 'geometry',
      stylers: [
        {
          color: '#eeeeee'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        {
          color: '#c9c9c9'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#9e9e9e'
        }
      ]
    }
  ];
  google: any = gmapApi;
  transformPosition(pos: any) {
    return {
      lat: parseFloat(pos.lat),
      lng: parseFloat(pos.lng),
      pos: parseInt(pos.srid)
    };
  }

  get mapIcon() {
    if (this.google.maps) {
      return this.google.maps.Icon({
        url: '../assets/dummy/blue-pin.png'
      });
    }
    return '../assets/dummy/blue-pin.png';
  }

  createMarkerLabel(text: string): any {
    return this.google.map.MarkerLabel({});
  }

  @Watch('activeTabIdx', { immediate: true })
  handleaActiveTabIdxChange(val: number, old: number) {
    if (val != old) {
      this.activeAddressIdx = 0;
      this.center = this.transformPosition(
        this.compData[this.activeTabIdx].content[this.activeAddressIdx].center
      );
    }
  }

  @Watch('activeAddressIdx', { immediate: true })
  handleaActiveAddressIdxChange(val: number, old: number) {
    console.log('change');
    this.center = this.transformPosition(
      this.compData[this.activeTabIdx].content[this.activeAddressIdx].center
    );
  }

  get currentAddress() {
    return this.compData[this.activeTabIdx].content[this.activeAddressIdx];
  }

  get mapImage() {
    return (
      HOST +
      this.compData[this.activeTabIdx].content[this.activeAddressIdx].content
        .image.original.src
    );
  }

  changeTab(idx: number) {
    this.activeTabIdx = idx;
    this.activeAddressIdx = 0;
  }
}
